import { MAX_CANDIDATE_ALTERNATIVE_PHONE_NUMBERS, MAX_CANDIDATE_FREE_TEXT_LENGTH } from '@pflegia/types/common/candidate/constants';
import { UNCONFIRMED_NOTIFICATIONS_THRESHOLD } from '@pflegia/types/common/constants/notification';
import { MIN_PASSWORD_LENGTH } from '@pflegia/types/common/constants/password';

export const MAX_DEPARTMENTS_IN_PROFILE = 5;
export { MAX_LOCATIONS_IN_PROFILE } from '@pflegia/types/common/constants/candidate';
export const MAX_COVER_LETTER_LENGTH = 5000;
export const MAX_JOB_TITLE_QUERIES = 3;
export const MIN_JOB_TITLE_QUERY_LENGTH = 3;
export const MAX_JOB_TITLE_QUERY_LENGTH = 32;

export const MAX_PASSWORD_LENGTH = 25;
export const MAX_EMPLOYMENT_HOURS = 40;
export const MAX_ABOUT_YOU_SELECTIONS = 3;
export const MAX_DOCUMENTATION_SYSTEMS = 3;
export const MAX_WORK_HISTORY_DESCRIPTION = 3000;
export const MAX_WISHES_TEXT_LENGTH = 1000;
export const MAX_ACADEMIC_TITLE_LENGTH = 50;
export const MIN_EMPLOYMENT_HOURS = 0;

export enum CandidateSection {
  JobTitle = 'Job-Title',
  Education = 'Education',
  Experience = 'Experience',
  General = 'General',
}

export const DEFAULT_FILTER_RANGE_IN_KM = 10;

export {
  /** @deprecated Import from @pflegia/types/common instead. */ MAX_CANDIDATE_ALTERNATIVE_PHONE_NUMBERS,
  /** @deprecated Import from @pflegia/types/common instead. */ MAX_CANDIDATE_FREE_TEXT_LENGTH,
  /** @deprecated Import from @pflegia/types/common instead. */ MIN_PASSWORD_LENGTH,
  /** @deprecated Import from @pflegia/types/common instead. */ UNCONFIRMED_NOTIFICATIONS_THRESHOLD,
};
